import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import api from "../../lib/api";
import { pushSignUp } from "../../lib/signupEvent";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/connexion", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (res.data.mfa_pending && res.data.demo_code) {
          sessionStorage.setItem("mfa_demo_code", res.data.demo_code);
        }
        if (res.data.is_new) pushSignUp("google", res.data.user_id);
        setUser(res.data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/connexion", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-softer">
      <span className="w-14 h-14 rounded-2xl bg-brand-lime flex items-center justify-center animate-pulse mb-5">
        <Home className="w-7 h-7 text-brand-greenDeep" strokeWidth={2.4} />
      </span>
      <p className="font-display text-xl text-brand-greenDeep">Connexion en cours...</p>
      <p className="text-sm text-brand-green/50 mt-1">Un instant, nous préparons votre espace.</p>
    </div>
  );
}
